import { encodePeriodValue, GlobalPeriodSelect } from '@components'

import React, { ReactElement, useCallback } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { PeriodValue } from '../../../../../../types/periodValue'
import { defaultTransactionsQuery } from '../../../../constants/defaultTransactionsQuery'
import { useTransactionsListFilters } from '../../../../contexts/transactionsListFiltersContext'

export const TransactionsPeriodSelector = (): ReactElement => {
  const { organization } = useUserOrganization()
  const {
    appliedFilters: { period: queryParamPeriod },
    setFilters: setQueryParams,
  } = useTransactionsListFilters()

  const handlePeriodChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organization?.id) {
        return
      }

      setQueryParams({ period: encodePeriodValue(periodValue, organization.id), page: defaultTransactionsQuery.page })
    },
    [organization, setQueryParams],
  )

  return <GlobalPeriodSelect encodedPeriod={queryParamPeriod} onChange={handlePeriodChange} placement="bottom-end" />
}
